module.exports = __webpack_public_path__ + "static/waxing1-82e8da04ad906fc1c53657b1757e6e20.jpg";